import React, { useState } from "react";
import { RefetchProvider, useDebounce } from "@piiqtechnologies/ui-lib";
import { PeekGrid, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import { Outlet } from "react-router-dom";
import SearchText from "@components/common/search-text";
import { useIntl } from "react-intl";
import { messages } from "./messages.i18n";
import AppHeader from "@components/app-header";
import { SpaceToolBar } from "@components/space-details";
import { GlobeV2 } from "@piiqtechnologies/svg-icons";
export const SpacesLayout = () => {
    const intl = useIntl();
    const isSgtSettings = window.location.pathname.includes("sgt-settings");
    const [searchKey, setSearchKey] = useState(null);
    const debouncedSearchKey = useDebounce(searchKey, 700);
    const [layoutConfig, setLayoutConfig] = useState({
        pageTitle: "",
        backButton: false,
        spaceDetails: null,
        displaySearch: false,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekGrid, { item: true, xs: 12, display: "flex", justifyContent: "space-between" },
            React.createElement(PeekStack, { direction: "row", spacing: 4, alignItems: "center" },
                React.createElement(AppHeader, { headerLabel: layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.pageTitle, icon: !isSgtSettings && (React.createElement(PeekTypography, { variant: "h2", display: "flex" },
                        React.createElement(GlobeV2, null))), backButton: layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.backButton, onBackButtonClick: layoutConfig.onBack }),
                (layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.displaySearch) && (React.createElement(SearchText, { placeholder: intl.formatMessage(messages.spacesCommunitySearch), searchText: searchKey, onChange: setSearchKey }))),
            (layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.spaceDetails) && React.createElement(SpaceToolBar, { spaceDetails: layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.spaceDetails })),
        React.createElement(PeekGrid, { item: true, xs: 12 },
            React.createElement(RefetchProvider, null,
                React.createElement(Outlet, { context: { setLayoutConfig, searchKey: debouncedSearchKey } })))));
};
